package gr.tech.GRAttestation.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.silk.components.text.SpanText
import gr.tech.GRAttestation.models.storeusers.STORE_USERS_STATUS


@Composable
fun StoreUserStatusBadge(
    storeUserStatusBitwise: Short,
) {
    val status = STORE_USERS_STATUS.parseStatus(storeUserStatusBitwise)

    SpanText(
        text = status.status,
        modifier = Modifier.classNames(
            "badge",
            when (status) {
                STORE_USERS_STATUS.ACTIVE -> "text-bg-success"
                STORE_USERS_STATUS.DISABLED -> "text-bg-warning"
                STORE_USERS_STATUS.DELETED -> "text-bg-danger"
                STORE_USERS_STATUS.PENDING -> "text-bg-primary"
            }
        )
    )
}